const Backbone = require('backbone');
const window = require('window');
const externalScriptLoader = require('externalScriptLoader');

/**
 * This view handles client side validation for making sure the widget returns a token successfully.
 * Additional validation to validate the token should be done on the
 * server side using the middleware `src/lib/middleware/validate_captcha.ts`
 * @example @AddMiddleware(validateCaptcha)
 */
module.exports = Backbone.View.extend({
	captchaSuccess: false,
	events: {
		submit: '_handleSubmit'
	},
	initialize: function(options = {}) {
		externalScriptLoader('//www.google.com/recaptcha/api.js?onload=onloadRecaptchaCallback&render=explicit', () => {
			this.submitButton = '[type="submit"]';
			this._addCaptchaContainer();
			// Use is rendered immediately if you delayed the creation of the captcha view
			if (options.isRenderedImmediately) {
				this._handleNow();
			} else {
				this._handleOnLoad();
			}
		});
	},
	_addCaptchaContainer: function() {
		this.$el.find(this.submitButton).before('<div id="captcha-container"></div>');
	},
	_verifyCallback: function(response) {
		this.captchaSuccess = Boolean(response);
		if (!this.captchaSuccess) {
			window.BCOM.notifications.render('Sorry, there was an error verifying CAPTCHA. Please try again.', 'warning');
			window.grecaptcha.reset();
		}
	},
	_handleOnLoad: function() {
		window.onloadRecaptchaCallback = function() {
			this.renderCaptcha();
		}.bind(this);
	},
	_handleNow: function() {
		this.renderCaptcha();
	},
	_handleSubmit: function() {
		if (this.$el.valid() && !this.captchaSuccess) {
			window.BCOM.notifications.render('Please verify CAPTCHA', 'warning');
			return false;
		}

		return true;
	},
	isCaptchaSuccess: function() {
		return this.captchaSuccess;
	},
	resetCaptcha: function() {
		this.captchaSuccess = false;
		window.grecaptcha.reset();
	},
	_errorCallback: () => {
		this.captchaSuccess = false;
	},
	renderCaptcha: function() {
		window.grecaptcha.render('captcha-container', {
			sitekey: window.dataLayer.captchaPublicKey,
			callback: this._verifyCallback.bind(this),
			'expired-callback': this._errorCallback.bind(this),
			'error-callback': this._errorCallback.bind(this)
		});
	}
});
